import { Severity, trackException, trackMessage } from './instrument';

export function getLoggerInstance(context: string) {
  return {
    error: (message: string, data?: Record<string, unknown> & { exception?: unknown }) => {
      if (data?.exception && data?.exception instanceof Error) {
        const { exception, ...properties } = data;
        trackException(exception, Severity.error, {
          ...properties,
          message: `[${context}] ${message}`,
        });
      } else {
        trackMessage(`[${context}] ${message}`, Severity.error, data);
      }
      // Log to console as well for debugging
      // eslint-disable-next-line no-console
      console.error(context, message, data);
    },
    warn: (message: string, data?: Record<string, unknown>) => {
      trackMessage(`[${context}] ${message}`, Severity.warning, data);
      // Log to console as well for debugging
      // eslint-disable-next-line no-console
      console.warn(context, message, data);
    },
    debug: (message: string, data?: Record<string, unknown>) => {
      trackMessage(`[${context}] ${message}`, Severity.debug, data);
      // Log to console as well for debugging
      // eslint-disable-next-line no-console
      console.log(context, message, data);
    },
    /**
     * Use only for tracking contexts where the level is not known in advance.
     */
    track(level: Severity, message: string, data?: Record<string, unknown>) {
      if (level === Severity.warning) {
        this.warn(message, data);
      } else if (level === Severity.debug) {
        this.debug(message, data);
      } else {
        this.error(message, data);
      }
    },
  };
}
